"use client";

import SyntheticHero from "./synthetic-hero";

interface HeroSectionProps {
    videoSrc?: string;
}

export function HeroSection({ videoSrc }: HeroSectionProps) {
    return (
        <SyntheticHero
            title="Launch your dream MVP in just one week."
            description="We turn your idea into a working product — fast, functional, and ready for investors or early users. No waiting. No overbuilding. Just pure execution."
            badgeText="OneWeekMVPs"
            badgeLabel="Launch in 7 Days"
            ctaButtons={[
                { text: "Start Your MVP", href: "https://cal.com/buildwithrishi/15min", primary: true },
                { text: "See How It Works", href: "#process" },
            ]}
            microDetails={[
                "7-day build framework",
                "Investor-ready designs",
                "Real users, real traction",
            ]}
        />
    );
}


